const getEndOfMonth = (
  date: Date = new Date(),
  offsetMonths: number = 0,
): Date => new Date(date.getFullYear(), date.getMonth() + offsetMonths + 1, 0);

export default getEndOfMonth;
